import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MaterialProductsContent, BreadcrumbAboutIsn, BannerAbout, HousingMaterialMenu } from '../../common'
import { useParams } from 'react-router';
import { getHousingMaterialProducts } from '../../aboutIsn.api';
import { getLanguage, getQueryString } from 'utils/params';
import { useLocation } from 'react-router';


const MaterialProductComponent = () => {
    const { t } = useTranslation();
    const { productid } = useParams();
    const [ productDetail, setProductDetail] = useState({});
    const language = getLanguage(useLocation());
    useEffect(() => {
        // let product = productList.filter(el => { return el.id === Number.parseInt(productid)})[0];
        // setProductDetail(product);
        getHousingMaterialProducts(getQueryString({ language })).then(res => {
          if (res && res.length > 0) {
            let product = res.filter(el => { return el.id === Number.parseInt(productid)})[0];
            setProductDetail(product)
          }
        })
        //eslint-disable-next-line
    },[productid])

    useEffect(()=> {
        window.scrollTo({top: 0, behavior: 'smooth'});
    },[])

    const breadCrumb = [
        { title: t('about_isn.home'), url: '/' },
        { title: t('about_isn.about_us'), url: '/about-us' },
        { title: t('about_isn.housing_materials'), url: '/about-us/housing-material/overview' },
        { title: `${productDetail?.title}`}
    ];


    return (
        <>
            <div id="position-scroll"></div>
            <BreadcrumbAboutIsn breadCrumb={breadCrumb} />
            <section className="profile-company group-company">
                <BannerAbout banner={{ img: `${productDetail?.bannerUrl}`, title:  `${productDetail?.title}`}} />
                <HousingMaterialMenu />
                <div className="container">
                    <MaterialProductsContent data={productDetail} />
                </div>
            </section>
        </>
    )
}
export default MaterialProductComponent;
